import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "arrow", "text"]
  static values = {
    page: { type: Number, default: 1 },
    loading: { type: Boolean, default: false }
  }

  loadMore(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    if (this.loadingValue) return false

    this.loadingValue = true
    this.setLoadingState(true)

    const destinationUrl = new URL(window.location.href)
    destinationUrl.pathname = "/ai-jobs"

    const currentPage = parseInt(destinationUrl.searchParams.get("page") || this.pageValue || "1", 10)
    const nextPage = currentPage + 1

    destinationUrl.searchParams.set("page", nextPage)
    destinationUrl.searchParams.delete("load_more")

    window.location.href = destinationUrl.toString()
    return false
  }

  setLoadingState(isLoading) {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = isLoading
      this.buttonTarget.classList.toggle("loading", isLoading)
    }

    if (this.hasTextTarget) {
      this.textTarget.textContent = isLoading ? "Loading Jobs..." : "Show More Jobs"
    }

    if (this.hasArrowTarget) {
      this.arrowTarget.style.animation = isLoading ? "spin 0.5s linear infinite" : ""
    }
  }
}
